// import { PropaneTankSharp } from "@mui/icons-material";
import { useEffect, useState } from "react";
// import AxiosInstance from "../Axios";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import AxiosInstance from "src/components/Axios";

const urlApi = '/languages';

const LangugesPanel = ({ data, setLaguage, language }) => {

   const navigate = useNavigate();

   const [languagesList, setLaguagesList] = useState([]);
   const [translations, setTranslations] = useState((data != undefined && data.translations != undefined) ? data.translations : false);

   //флаг для search
   let search = true
   const getLangs = () => {
      AxiosInstance.get(`${urlApi}?page=1`).then((response) => {
         setLaguagesList(response.data['hydra:member'])
      })
   }

   useEffect(() => {
      setLaguage((data != undefined && data.language != undefined) ? data.language.key : 'en');
      setTranslations(prev => data.translations)
      getLangs();
   }, [data]);


   const CreateTranslate = (e, l) => {

      const data_response = {
         name: '',
         content: '',
         latitude: data.latitude,
         longitude: data.longitude,
         status: data.status,
         dateEntered: data.dateEntered,
         show: data?.show !== undefined ? data?.show : false,
         ...(data?.mainMedia ? { mainMedia: `/api/media_objects/${data.mainMedia.id}` } : {}),
         ...(data?.attributeItems !== undefined && {attributeItems: data.attributeItems.map(attr => attr.translations.find(trans => trans.language.id === l.id)?.["@id"]).filter(id => id !== undefined)}),
         ...(data?.modelsObject !== undefined && {modelsObject: data.modelsObject.map(attr => attr["@id"] )}),
         ...(data?.galleries !== undefined && {galleries: data.galleries.map(gallery => gallery["@id"] )})
      };

      data_response['language'] = `/api/languages/${l.id}`;
      data_response['translation'] = `/api/objects/${data.id}`;

      AxiosInstance.post(`/objects`, data_response).then((response) => {
         if (response.status === 201) {
            return navigate(`/objects/update/${response.data.id}`);
         }
      }).catch((error) => {
         console.error("Error creating translation:", error);
      });
   }

   return (
      <div>
         {/* <div>: </div> */}
         <div>
            <ul>
               {
                  (data != undefined && data.translation != undefined && data.translation && data.translation.id != undefined) ?
                     <>
                        <h4>Переклад: {language}</h4>
                        <Button variant="outline-secondary ml-5" >
                           <Link to={`/objects/update/${data.translation.id}`}>{data.translation?.language?.key || 'en'}</Link>
                        </Button>
                     </>
                     :
                     <>
                        <h4>Переклад: {language}</h4>
                        {/* <li className='btn btn-secondary text-white'>{language}</li> */}
                        {languagesList.map((l) => {
                           // let search = true;
                           search = true
                           // console.log('translations', translations);
                           if (l.key != language) {
                              // if (translations !== false) {
                              if (translations?.length > 0) {
                                 let t = translations.filter(t => t.language.key === l.key)
                                 if (t.length > 0) {
                                    // console.log('search', search)
                                    return (<Button key={l.id} variant="outline-secondary ml-5" ><Link to={`/objects/update/${t[0].id}`} >{l.key}</Link></Button>);
                                 }
                                 else
                                    search = false;

                              } else {
                                 search = false;

                              }
                           }
                           if (!search) {
                              return (<Button key={l.id}
                                 variant="outline-secondary mr-5"
                                 onClick={(e) => { CreateTranslate(e, l) }}
                              >
                                 додати  <b>{l.key}</b>
                              </Button>);
                           }

                        })}
                     </>
               }
            </ul>
         </div>

      </div>
   );

}

export default LangugesPanel;